import { inject } from '@angular/core'
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http'
import { EMPTY, switchMap, take } from 'rxjs'
import { AuthService } from '@features/auth/auth.service'
import { catchError } from 'rxjs/operators'
import { Router } from '@angular/router'
import { addAuthorizationHeader } from '@features/http/util/add-authorization-header'
import { APP_ROUTE_NAMES } from '@app/app.routes'
import { REFRESH_ON_UNAUTHORIZED } from '@features/http/refresh-token.context'

const nonAuthError = (e: HttpErrorResponse) => e.status !== HttpStatusCode.Unauthorized

export const refreshTokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (!request.context.get(REFRESH_ON_UNAUTHORIZED)) {
    return next(request)
  }

  if (!request.url.startsWith('/auth')) {
    return next(request)
  }

  const auth = inject(AuthService)
  const router = inject(Router)

  const logout = () => {
    auth.logout()
    router.navigate(['/', APP_ROUTE_NAMES.LOGIN], { state: { redirectTo: router.url } })
  }

  return next(request).pipe(
    catchError(e => {
      if (nonAuthError(e)) {
        throw e
      }

      return auth.refresh()
        .pipe(
          take(1),
          catchError(() => {
            logout()

            return EMPTY
          }),
          switchMap(token => next(addAuthorizationHeader(request, token))),
          catchError(e => {
            if (nonAuthError(e)) {
              throw e
            }

            logout()

            return EMPTY
          }),
        )
    }),
  )
}
